import { formatDateTimeLocaleWithTime } from '@rd-web-markets/shared/dist/util/date/dateUtils';
import { REVIEW_STATUS } from '@rd-web-markets/market/dist/constants';
import React from 'react';
import { Row, Col } from 'react-bootstrap';
const ReviewHistoryItem = _ref => {
  let {
    review,
    showStatus = true
  } = _ref;
  const isClosed = review.status === REVIEW_STATUS.CLOSED || review.status === REVIEW_STATUS.FINALIZED;
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-4 pb-3"
  }, review.reviewer_comments && /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 3,
    className: "small"
  }, /*#__PURE__*/React.createElement("strong", null, "Reviewer Comments:"), review.reviewer_initials && /*#__PURE__*/React.createElement("div", {
    className: "mt-1 text-muted"
  }, "by ", review.reviewer_initials), review.reviewed_at && /*#__PURE__*/React.createElement("div", {
    className: "text-muted"
  }, formatDateTimeLocaleWithTime(review.reviewed_at))), /*#__PURE__*/React.createElement(Col, {
    md: 9
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      whiteSpace: 'pre-wrap',
      fontSize: '0.95rem'
    }
  }, review.reviewer_comments))), review.consultant_response && /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 3,
    className: "small"
  }, /*#__PURE__*/React.createElement("strong", null, "Consultant Response:"), review.responded_at && /*#__PURE__*/React.createElement("div", {
    className: "mt-1 text-muted"
  }, formatDateTimeLocaleWithTime(review.responded_at))), /*#__PURE__*/React.createElement(Col, {
    md: 9
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      whiteSpace: 'pre-wrap',
      fontSize: '0.95rem'
    }
  }, review.consultant_response))), showStatus && isClosed && review.closed_at && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 3,
    className: "small"
  }, /*#__PURE__*/React.createElement("strong", null, "Status:")), /*#__PURE__*/React.createElement(Col, {
    md: 9
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-success",
    style: {
      fontSize: '0.95rem'
    }
  }, "Closed at ", formatDateTimeLocaleWithTime(review.closed_at)))));
};
export default ReviewHistoryItem;